<template>
  <div class="black-hole-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>Rs = 2GM / c² (史瓦西半径)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Backgroun stars -->
          <circle v-for="n in 50" :key="'s'+n" :cx="Math.random()*400" :cy="Math.random()*240" r="1" fill="#fff" opacity="0.3" />

          <!-- Accretion Disk (Visualized as glowing rings) -->
          <ellipse cx="200" cy="120" :rx="radius*3" :ry="radius*0.8" fill="none" stroke="rgba(255, 165, 0, 0.4)" stroke-width="15" />
          <ellipse cx="200" cy="120" :rx="radius*2.5" :ry="radius*0.6" fill="none" stroke="rgba(255, 69, 0, 0.6)" stroke-width="5" />

          <!-- The Event Horizon -->
          <circle cx="200" cy="120" :r="radius" fill="#000" stroke="rgba(255, 255, 255, 0.2)" />
          
          <!-- Photon Sphere (Light Bending) -->
          <circle cx="200" cy="120" :r="radius*1.5" fill="none" stroke="rgba(0, 210, 255, 0.2)" stroke-dasharray="10, 10">
             <animateTransform attributeName="transform" type="rotate" from="0 200 120" to="360 200 120" dur="10s" repeatCount="indefinite" />
          </circle>

          <!-- Light rays bending -->
          <path v-for="i in 3" :key="'r'+i" :d="calcRay(i)" fill="none" stroke="#ffd700" opacity="0.4" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>光线在强引力场下的曲率</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>黑洞质量 M</label>
             <el-slider v-model="mass" :min="1" :max="50" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>黑洞是广义相对论预言的极端天体。当物质被压缩到其**史瓦西半径**内时，引力变得如此之强，以至于连光也无法逃脱，这个边界称为**事件视界**。周围旋转的物质形成强烈的吸积盘。引力还会产生显著的**光线弯曲**（引力透镜效应），使得我们能看到黑洞后方的天体。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlackHoleViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      mass: 10
    }
  },
  computed: {
    radius() { return 20 + this.mass; }
  },
  methods: {
    calcRay(i) {
       let y = 60 + i * 40;
       return `M 0 ${y} Q 200 ${y - (this.radius * 0.5)} 400 ${y}`;
    }
  }
}
</script>

<style scoped lang="scss">
.black-hole-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 69, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
